const enum MissionEventType {
    None = 0,
    Create = 1,
    Wait = 2,
    Process = 3,
    Cancel = 4,
    Done = 5
}

export default MissionEventType;